export default "__VITE_ASSET__Bp33kgs___"